import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const NUTRI_FIELDS = [
  { key: "energy_kcal", label: "Energia (Kcal)", ph: "230" },
  { key: "energy_kj", label: "Energia (KJ)", ph: "962" },
  { key: "fats_g", label: "Greixos (g)", ph: "10" },
  { key: "saturated_fats_g", label: "Greixos saturats (g)", ph: "4,3" },
  { key: "carbohydrates_g", label: "Hidratos (g)", ph: "22" },
  { key: "sugars_g", label: "Azúcars (g)", ph: "1,8" },
  { key: "proteins_g", label: "Proteïnes (g)", ph: "10" },
  { key: "fiber_g", label: "Fibra (g)", ph: "1,5" },
  { key: "salt_g", label: "Sal (g)", ph: "1,1" },
];

const ORGANO_FIELDS = [
  { key: "color", label: "Color", ph: "Ex: Vermell, beix, groc" },
  { key: "flavor", label: "Sabor", ph: "Ex: Tomàquet, formatge i mozzarella" },
  { key: "smell", label: "Olor", ph: "Ex: Mozzarella fresca" },
  { key: "texture", label: "Textura", ph: "Ex: Base cruixent i farcit sucós" },
];

export function RecipeNutrition({ form, setForm }) {
  const updateNutri = (key, value) => {
    setForm({ ...form, nutritional_info: { ...form.nutritional_info, [key]: value } });
  };

  const updateOrgano = (key, value) => {
    setForm({ ...form, organoleptic_characteristics: { ...form.organoleptic_characteristics, [key]: value } });
  };

  const updateMicro = (key, value) => {
    setForm({ ...form, microbiological_tests: { ...form.microbiological_tests, [key]: value } });
  };

  return (
    <>
      {/* Nutritional */}
      <div className="border-t pt-4">
        <h3 className="font-semibold text-sm mb-3">Informació nutricional per 100g</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {NUTRI_FIELDS.map(f => (
            <div key={f.key}>
              <Label className="text-xs">{f.label}</Label>
              <Input type="number" step="0.1" placeholder={f.ph} value={form.nutritional_info[f.key]} onChange={(e) => updateNutri(f.key, e.target.value)} />
            </div>
          ))}
        </div>
      </div>

      {/* Organoleptic */}
      <div className="border-t pt-4">
        <h3 className="font-semibold text-sm mb-3">Característiques organolèptiques</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {ORGANO_FIELDS.map(f => (
            <div key={f.key}>
              <Label className="text-xs">{f.label}</Label>
              <Input placeholder={f.ph} value={form.organoleptic_characteristics[f.key]} onChange={(e) => updateOrgano(f.key, e.target.value)} />
            </div>
          ))}
        </div>
        <div className="mt-3">
          <Label className="text-xs">Aspecte</Label>
          <Input placeholder="Ex: Pizza de massa fina amb farcit de mozzarella" value={form.organoleptic_characteristics.appearance} onChange={(e) => updateOrgano("appearance", e.target.value)} />
        </div>
      </div>

      {/* Microbiological */}
      <div className="border-t pt-4">
        <h3 className="font-semibold text-sm mb-3">Tests microbiològics</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs">Salmonella</Label>
            <Input placeholder="Ex: Absència en 25g" value={form.microbiological_tests.salmonella} onChange={(e) => updateMicro("salmonella", e.target.value)} />
          </div>
          <div>
            <Label className="text-xs">Listeria monocytogenes</Label>
            <Input placeholder="Ex: Absència en 25g" value={form.microbiological_tests.listeria} onChange={(e) => updateMicro("listeria", e.target.value)} />
          </div>
        </div>
      </div>
    </>
  );
}
